import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  imports: [CommonModule, MatDialogModule, MatProgressBarModule],
  selector: 'shared-wait-dialog',
  templateUrl: './wait-dialog.component.html',
  styleUrls: ['./wait-dialog.component.scss'],
})
export class WaitDialogComponent {
  data = inject<{
    title?: string;
}>(MAT_DIALOG_DATA);
}
